module.exports = __webpack_public_path__ + "img/dynamicBanner.96c3e10d.png";